import { render } from 'preact';
import { TranslationsProvider } from '@eo-locale/preact';
import { unmountComponentAtNode } from 'preact/compat';
import { FullPageWidgetSettings } from 'types/settings';
import { WIDGET_COMPONENTS, WIDGET_CONTAINERS } from 'utilities/app';

import { AppProvider } from 'components/AppProvider';

import { FullPageWidget } from './FullPageWidget';

if (!WIDGET_CONTAINERS.fullPage) {
  throw new Error(
    `Full page widget: container element 
    '${WIDGET_CONTAINERS.fullPage}' was not found`,
  );
}

export class wbtxFullPageWidget extends HTMLElement {
  connectedCallback() {
    const settingsAttr = this.getAttribute('data-settings');

    if (settingsAttr === null) {
      throw new Error(
        'Webtex Reviews: No settings detected for full page widget.',
      );
    }

    const settings: FullPageWidgetSettings = JSON.parse(settingsAttr);

    const onRemove = () => {
      render(null, this);
      this.remove();
    };

    render(
      <AppProvider settings={settings}>
        <TranslationsProvider
          locales={window.wbtxReviewsUtils.translations}
          language={window.wbtxReviewsUtils.locale}
          onError={console.warn}
        >
          <FullPageWidget onRemove={onRemove} />
        </TranslationsProvider>
      </AppProvider>,
      this,
    );
  }
}

if (!customElements.get(WIDGET_COMPONENTS.fullPage)) {
  customElements.define(WIDGET_COMPONENTS.fullPage, wbtxFullPageWidget);
}
